/** DuoMat bleu theme — branding taken from duomat.fr (navy / orange / sky blue, Manrope + DM Sans). */
export default {
  id: 'duomat-bleu',
  label: 'DuoMat bleu',

  brand: {
    appName: 'DuoMat',
    assistantName: 'DuoMat',
    loginName: 'DUOMAT',
    company: 'Starkia Technologies',
    tagline: 'Votre Binôme IA du commerce matériaux.',
    loginBullets: [
      'Le commercial reste aux commandes',
      'Devis matériaux préparés par l’IA',
      'Intégration ERP & catalogues fournisseurs',
    ],
    pdfFooter: 'Document généré par DuoMat',
  },

  assets: {
    logo: '/themes/duomat/logo.png',
    // White-lettered variant, used in dark mode.
    logoDark: '/themes/duomat/logo-dark.png',
    favicon: '/themes/duomat/favicon.png',
  },

  colors: {
    light: { primary: '#5b9bd5', secondary: '#1f4e7a', accent: '#f47920', cta: '#f47920', info: '#8cbbe6' },
    dark: { primary: '#5b9bd5', secondary: '#5b9bd5', accent: '#f47920', cta: '#f47920', info: '#8cbbe6', background: '#183f63', surface: '#1f4e7a' },
    tokens: {
      light: {
        loginInfoBg: '#eef3f9',
        contentBg: '#1f4e7a',
        promptBg: 'rgba(255, 255, 255, 0.14)',
        promptText: '#ffffff',
        promptLabel: '#d6e8f8',
        questionLabel: '#ffffff',
        loadingDot: '#d6e8f8',
        textMuted: '#3d4757',
        textMutedOnDark: '#d6e8f8',
        textStrong: '#151e2d',
        surfaceBg: '#1f4e7a',
        surfaceRaised: '#27608f',
        contentText: '#ffffff',
        cardBg: '#27608f',
        cardBorder: '#3d77a8',
        assistantMsgBg: '#27608f',
        assistantBubbleTextMsg: '#ffffff',
        userBubbleBg: '#c95a0c',
        headingColor: '#ffb27a',
        assistantBubbleBg: '#27608f',
        assistantBubbleText: '#ffffff',
        thinkingDot: '#ffb27a',
        accountIcon: '#5b9bd5',
      },
      dark: {
        loginInfoBg: '#151e2d',
        contentBg: '#183f63',
        promptBg: 'rgba(255, 255, 255, 0.14)',
        promptText: '#ffffff',
        promptLabel: '#d6e8f8',
        questionLabel: '#ffffff',
        loadingDot: '#d6e8f8',
        textMuted: '#3d4757',
        textMutedOnDark: '#d6e8f8',
        textStrong: '#151e2d',
        surfaceBg: '#183f63',
        surfaceRaised: '#1f4e7a',
        contentText: '#ffffff',
        cardBg: '#1f4e7a',
        cardBorder: '#2f6fae',
        assistantMsgBg: '#1f4e7a',
        assistantBubbleTextMsg: '#ffffff',
        userBubbleBg: '#c95a0c',
        headingColor: '#ffb27a',
        assistantBubbleBg: '#1f4e7a',
        assistantBubbleText: '#ffffff',
        thinkingDot: '#ffb27a',
        accountIcon: '#5b9bd5',
      },
    },
  },

  fonts: {
    family: "'DM Sans', system-ui, sans-serif",
    headingFamily: "'Manrope', system-ui, sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=DM+Sans:wght@400;500;700&display=swap',
  },

  layout: {
    borderRadius: 10,
    sidebarLogoHeight: 36,
    loginLogoHeight: 36,
    contentDark: true,
    activeItemColor: 'cta',
  },
}
